import { Container } from '@grupoboticario/flora-react';

import { ErrorBoundaries } from 'components';
import { ptBRCadastralChangeName } from 'helpers';

import StylesDrawer from '../../../../Drawers.styles';

export const MessageTryAgain = ({ type }: { type: string }) => {
  const textFormatted = `Não foi possível solicitar a alteração de ${ptBRCadastralChangeName[type]}.`;
  return (
    <StylesDrawer.DrawerSection>
      <Container size='medium' data-autotagging-flora-section={`alterar_${type}`}>
        <ErrorBoundaries.ReloadPage
          title={textFormatted}
          subtitle='Tente realizar a solicitação novamente. A solicitação será reiniciada.'
        />
      </Container>
    </StylesDrawer.DrawerSection>
  );
};

export default MessageTryAgain;
